import { render, staticRenderFns } from "./SoundEsthePurposeDetail.vue?vue&type=template&id=0fb71d5f&scoped=true&"
import script from "./SoundEsthePurposeDetail.vue?vue&type=script&lang=ts&"
export * from "./SoundEsthePurposeDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb71d5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
